<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	data() {
		return {
			rowClick: (item) => {
				this.$router.push({ name: 'DefaultParametersDetail', params: { id: item._id } })
			},
			items: [
				{ header: 'Nom', value: (item) => item.key, sort: 'key', filter: { name: 'key' } },
				{ header: 'Theme', value: (item) => item.theme, sort: 'theme', filter: { name: 'theme' } },
			],
		}
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/defaultParameters/defaultParameters.list.vue